import apiClient from './apiClient';

export const timesheetApi = {
    // ---- Entries ----
    getEntry: (id) => apiClient.get(`/api/timesheet/entry/${id}`).then(res => res.data),
    getEntries: (params) => apiClient.get(`/api/timesheet/entries`, { params }).then(res => res.data),
    createEntry: (data) => apiClient.post('/api/timesheet/entry', data).then(res => res.data),
    updateEntry: (id, data) => apiClient.put(`/api/timesheet/entry/${id}`, data).then(res => res.data),
    deleteEntry: (id) => apiClient.delete(`/api/timesheet/entry/${id}`).then(res => res.data),

    // ---- Actions ----
    submitEntry: (id) => apiClient.put(`/api/timesheet/entry/${id}/submit`).then(res => res.data),
    requestDeletion: (id, reason) => apiClient.post(`/api/timesheet/entry/${id}/request-deletion`, { reason }).then(res => res.data),
    cancelDeletionRequest: (id) => apiClient.post(`/api/timesheet/entry/${id}/cancel-deletion`).then(res => res.data),

    // ---- Helpers ----
    checkDate: (date) => apiClient.get(`/api/timesheet/check-date`, { params: { date } }).then(res => res.data),
    getSettings: () => apiClient.get('/api/timesheet/settings').then(res => res.data),
    getMyPermissions: () => apiClient.get('/api/timesheet/my-permissions').then(res => res.data),
};
